var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.report.length === 0 && _vm.loading === false)?_c('div',[_vm._v("\n  No data available\n")]):(_vm.report.length === 0)?_c('graph-skeleton',{staticClass:"mx-3"}):_c('div',[_c('highmaps',{ref:"highcharts",attrs:{"options":_vm.options}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a89efa98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/reports/components/maps/GlobalMap.vue
// module id = null
// module chunks = 